module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_main_3locations-e022234f989853aed20d4afee9a23bed.jpg";